/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';

export const IdColumn = styled.div`
  display: flex;
  justify-content: space-between;
  ${({paddingLeft}) => paddingLeft && css`
    padding-left: ${paddingLeft};
  `}
  div {
    display: flex;
  }
`

export const ChildrenRow = styled.tr`
`